export * from "./badge.component";